export class ModelSizeMinMaxModel {
    Minimum: number;
    Maximum: number;
}
